<template>
  <div
    ref="animateEl"
    :class="[
      rootClass,
      { 'inline-block': inlineBlock },
      immediately ? 'animate-init' : 'animate-element'
    ]"
    :style="totalDelay > 0 && { 'transition-delay': totalDelay + 'ms' }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    rootClass: {
      type: String,
      default: ''
    },
    inlineBlock: {
      type: Boolean,
      default: false
    },
    // 可选：是否在离开视口时隐藏（默认false，显示后保持可见）
    hideOnLeave: {
      type: Boolean,
      default: false
    },
    // 组序号（0开始）
    groupIndex: {
      type: Number,
      default: 0
    },
    // 组内元素序号（0开始）
    indexInGroup: {
      type: Number,
      default: 0
    },
    // 组间延迟（ms）
    groupDelay: {
      type: Number,
      default: 500
    },
    // 组内元素间隔延迟（ms）
    intraGroupDelay: {
      type: Number,
      default: 200
    },
    immediately: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 计算总延迟（组间延迟 + 组内延迟）
    totalDelay() {
      return (
        this.groupIndex * this.groupDelay +
        this.indexInGroup * this.intraGroupDelay
      )
    }
  },
  mounted() {
    // 只监听当前组件的根元素（通过ref获取）
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.$refs.animateEl.classList.add('visible')
          } else if (this.hideOnLeave) {
            this.$refs.animateEl.classList.remove('visible')
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px 50px 0px'
      }
    )

    // 只观察当前组件的元素
    this.observer.observe(this.$refs.animateEl)

    this.$nextTick(() => {
      // 等待DOM渲染完成
      // 初始检查当前元素是否在视口内
      const rect = this.$refs.animateEl.getBoundingClientRect()
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        this.$refs.animateEl.classList.add('visible')
      }
    })
  },
  beforeDestroy() {
    if (this.observer) {
      // 只停止观察当前组件的元素
      this.observer.unobserve(this.$refs.animateEl)
      this.observer.disconnect()
    }
  }
}
</script>

<style lang="scss" scoped>
// 定义关键帧动画（从初始到目标）
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-init {
  animation: fadeInUp 0.8s ease forwards;
}
.inline-block {
  display: inline-block;
}
.animate-element {
  opacity: 0;
  transform: translateY(80px);
  transition: opacity 0s ease, transform 0.5s ease-out;
}

.animate-element.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 保留步骤延迟样式 */
.step-1 {
  transition-delay: 0s !important;
}
.step-2 {
  transition-delay: 0.3s !important;
}
.step-3 {
  transition-delay: 0.6s !important;
}
.step-4 {
  transition-delay: 0.9s !important;
}
</style>
